import { z } from "zod";

export const identifyProviderSchema = z.enum(["firebase", "cognito"]);
export type IdentifyProvider = z.infer<typeof identifyProviderSchema>;
export const IdentifyProviderEnum = identifyProviderSchema.enum;
